import combineReducers from '@services/combineReducers';

import auth from './auth';
import control from './control';
import more from './more';
import settings from './settings';

const rootReducer = combineReducers({
  auth,
  control,
  more,
  settings,
});

export default rootReducer;
